import { canUseJobs } from "../jobs/access";

// Routes and selections come from the authenticated server response, never storage.
export function canViewPage(user, path) {
  // Own-job status/history uses the same access as the persistent header monitor.
  // Results and retries still enforce their original business grants server-side.
  if (path.split(/[?#]/)[0].replace(/\/$/, "") === "/jobs") return canUseJobs(user);
  if (!user || !Object.prototype.hasOwnProperty.call(user, "page_access")) return true;
  if (!Array.isArray(user.page_access) || !Array.isArray(user.page_routes)) return false;
  const clean = path.split(/[?#]/)[0].replace(/\/$/, "") || "/";
  let match = null;
  for (const page of user.page_routes) {
    if (!page || !Array.isArray(page.paths)) return false;
    for (const route of page.paths) {
      if (typeof route !== "string") return false;
      const exactOnly = ["/admin", "/dealer", "/portal", "/dashboard", "/settings", "/sister-companies"].includes(route);
      if ((clean === route || (!exactOnly && clean.startsWith(route + "/"))) && (!match || route.length > match.length)) {
        match = { key: page.key, length: route.length };
      }
    }
  }
  return !!match && user.page_access.includes(match.key);
}

export const roleHome = user => Object.prototype.hasOwnProperty.call(user || {}, "page_access") ? user.page_home :
  user?.role === "sister_company" ? "/sister-companies" : user?.role === "sales_dealer" ? "/dealer" : user?.role === "customer" ? "/portal" : "/admin";
